import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centers-new-center',
  templateUrl: './centers-new-center.component.html',
  styleUrls: ['./centers-new-center.component.scss']
})
export class CentersNewCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
